import { Spin } from 'antd';
import type { ButtonHTMLAttributes, ComponentType } from 'react';
import type { LinkProps } from 'react-router-dom';
import type { ModifierKeys } from 'styled-components-modifiers';

// Import types
import type { ButtonVariant } from 'types/views/buttons';

// Import styles
import { StyledButton } from './styles';

type ElementProps = ButtonHTMLAttributes<HTMLButtonElement> | LinkProps;

export type ButtonProps = ElementProps & {
	children: React.ReactNode;
	modifiers?: ModifierKeys;
	variant?: ButtonVariant;
	icon?: React.ReactElement;
	as?: 'button' | 'a' | ComponentType<LinkProps>;
	isLoading?: boolean;
};

export const Button = ({ children, modifiers = 'contained', variant = 'primary', icon, as = 'button', isLoading = false, ...rest }: ButtonProps) => (
	<StyledButton as={as} variant={variant} modifiers={modifiers} className="button__main" {...rest}>
		{isLoading ? (
			<Spin size="small" />
		) : (
			<>
				{icon && icon}
				{children}
			</>
		)}
	</StyledButton>
);
